module.exports = __webpack_public_path__ + "static/img/Frame@2x.046ac5e9.png";